import types from './RequestSortType';

export default class RequestSortTitle {
    static [types.DATE] = 'По дате';
    static [types.DEADLINE] = 'По сроку';
}
